import { Button, Form, Input, Spin, Switch, Typography, Select, Image as ImageTag } from 'antd'
import { useState } from 'react'
import { apiUpdatReportType } from '../../../../utils/api'
import { openMessage } from '../../Utils/MessageDisplay'
import { prMain } from '../../../../themeConfig'
import { UploadOutlined, DeleteFilled } from '@ant-design/icons'

export const ConfigurationModal = ({ openModal, setopenModal, setUpdated, dependencies }) => {
    const { Text } = Typography
    const { data } = openModal
    const [icon, setIcon] = useState([])
    const [url, setUrl] = useState(`${process.env.REACT_APP_ICON_URL}${data.assetFile.path}`)

    // const [addResult, setAddResult] = useState(false)
    const [iconError, setIconError] = useState(false)

    const [state, setstate] = useState({
        name: data.name,
        minTime: data.minTime,
        maxTime: data.maxTime,
        active: data.active,
        dependencyId: data.dependency.id,
        loading: false,
    })

    const handleUpload = (e) => {
        setIconError(false)
        if (!e) return

        var reader = new FileReader()

        reader.readAsDataURL(e.target.files[0])
        reader.onload = function (value) {
            var image = new Image()
            image.src = value.target.result

            image.onload = function () {
                var h = this.height
                var w = this.width

                if (h > 500 || w > 500) {
                    console.log('mal')
                    console.log(w + ' x ' + h)
                    setIconError(true)
                } else {
                    setIconError(false)
                    console.log('bien')
                    console.log(w + ' x ' + h)

                }
            }
        }


        setIcon(e.target.files[0])
        setUrl(URL.createObjectURL(e.target.files[0]))

    }

    const handleRemove = () => {
        setIcon([])
        setUrl('')
    }

    const handleSave = () => {
        setstate({ ...state, loading: true })
        let dataApi = {
            dependencyId: data.dependency.id,
            id: data.id,
            max_time: state.maxTime,
            min_time: state.minTime,
            active: state.active,
            name: state.name
        }
        apiUpdatReportType(data.id, dataApi, icon)
            .then(res => {
                if (res.status === 200) {
                    setopenModal({ ...openModal, isOpen: false, data: {} })
                    setstate({ ...state, loading: false })
                    openMessage({ message: `La configuración del servicio ${data.name} se ha actualizado correctamente`, type: 'success' })
                    setUpdated(prev => !prev)
                }
            }).catch(err => {
                console.log(err)
                setstate({ ...state, loading: false })
                openMessage({ message: `Ocurrio un error al actualizar la configuración del servicio ${data.name}`, type: 'error' })
            })
    }

    const handleChangeHours = (e, name) => {
        if (e.target.value === '') {
            e.target.value = 0
        }

        const regex = /[^\d]/u;
        if (regex.test(e.target.value)) {
            e.target.value = parseInt(e.target.value.substring(0, e.target.value.length - 1));
        } else {
            setstate(prev => ({ ...prev, [name]: parseInt(e.target.value) }))
        }
    }

    const handleChange = (e, name) => {
        switch (name) {
            case "dependencyId":
                setstate(prev => ({ ...prev, [name]: e }))
                break;

            case "name":
                setstate(prev => ({ ...prev, [name]: e.target.value }))
                break;

            case "icon":
                setstate(prev => ({ ...prev, [name]: e.file }))
                break;

            default:
                break;
        }

    }

    const handleChangeSwitch = (checked) => {
        setstate(prev => ({ ...prev, active: checked }))
    }

    return (
        <div>
            <Spin spinning={state.loading}>
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 20 }}>
                    <Typography.Title level={4} style={{ marginRight: 15 }}>{data.name}</Typography.Title>
                    <Switch style={{ marginTop: 5, backgroundColor: '#23ba27' }} onChange={handleChangeSwitch} checked={state.active} checkedChildren="Activo" unCheckedChildren="Inactivo" />
                </div>

                <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Form.Item
                            style={{ width: '50%', }} //change to 50% when Dependency is visible

                        >
                            <Text>Nombre</Text>
                            <Input onChange={(e) => handleChange(e, 'name')} value={state.name}>
                            </Input>
                        </Form.Item>

                        <Form.Item
                            style={{ marginLeft: 30, width: '50%' }}
                        >
                            <Text>Dependencia</Text>
                            <Select disabled={true} onChange={(e) => handleChange(e, "dependencyId")} defaultValue={state.dependencyId}>
                                {dependencies.map((item) => (
                                    <Select.Option value={item.id} key={item.id}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                    </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Form.Item
                        style={{ marginRight: 30 }}
                        help={state.minTime > state.maxTime ? 'El mínimo debe ser menor que el máximo' : ''}
                        validateStatus={state.minTime > state.maxTime ? 'error' : 'success'}
                    >
                        <Typography.Text>Mínimo (horas)</Typography.Text>
                        <Input onChange={e => handleChangeHours(e, 'minTime')} value={state.minTime} />
                    </Form.Item>

                    <Form.Item
                        help={state.minTime > state.maxTime ? 'El mínimo debe ser menor que el máximo' : ''}
                        validateStatus={state.minTime > state.maxTime ? 'error' : 'success'}
                    >
                        <Typography.Text>Máximo (horas)</Typography.Text>
                        <Input onChange={e => handleChangeHours(e, 'maxTime')} value={state.maxTime} />
                    </Form.Item>
                </div>


                <div style={{ width: '100%', height: 75, display: 'flex', flexDirection: 'row' }}>
                        <div style = {{ display: 'flex', flexDirection: 'column' }}>

                        <label style={{ backgroundColor: prMain, height: 'fit-content', width: 'fit-content', padding: '5px 15px', borderRadius: 50 }} className='input-container' >
                            <UploadOutlined style={{ marginRight: 5 }} />
                            <input
                                id={'icono'}
                                className='inputSelect'
                                type="file"
                                accept='image/png'
                                name={'icono'}
                                onChange={handleUpload}
                            />
                            Seleccionar Icono
                        </label>
                        <Text style = {{ fontSize: 12, color: iconError ? "#ff0000" : '#aaaaaa', marginTop: 20 }}>
                            Favor de subir icono de m&aacute;ximo 500 x 500 pixeles
                        </Text>
                        </div>

                        <div style={{ marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {
                                url
                                    ? <ImageTag id={1} src={url} alt={'Icono'} height={75} width={75} style={{ objectFit: 'cover' }} />
                                    : <ImageTag
                                        style={{ objectFit: 'cover' }}
                                        width={75}
                                        height={75}
                                        src="error"
                                        fallback="data:image/png;base64,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"
                                    />
                            }
                            <Button icon={<DeleteFilled />} disabled={!url} type='link' onClick={() => handleRemove()}>Remover</Button>
                        </div>
                    </div>

                <Button
                    style={{ marginTop: 20 }}
                    disabled={state.minTime > state.maxTime || state.minTime === 0 || state.maxTime === 0}
                    type='primary'
                    onClick={handleSave}
                >Guardar</Button>
                <Button
                    type='link'
                    onClick={() => setopenModal(prev => ({ ...prev, isOpen: false, data: {} }))}
                >Cerrar</Button>
            </Spin>
        </div>
    )
}
